import { render, staticRenderFns } from "./QaSetting.vue?vue&type=template&id=4754101d&scoped=true"
import script from "./QaSetting.vue?vue&type=script&lang=js"
export * from "./QaSetting.vue?vue&type=script&lang=js"
import style0 from "./QaSetting.vue?vue&type=style&index=0&id=4754101d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4754101d",
  null
  
)

export default component.exports